import {
	FormGroup
} from '@angular/forms';

import {
	BannerModel,
	LinkModel
} from 'dd1pnds-ngx-libs';

export interface RadioButtonModel {
	label: { principal: string, secondaire?: string };
	value: any;
}

export function buildRadioButtonModel(value: string, principal: string, secondaire = null): RadioButtonModel {
	return {
		value: value,
		label: {
			principal: principal,
			secondaire: secondaire
		}
	};
}

/**
 * Model of the information displayed before the questions of a form.
 */
export interface FormFieldDescriptionModel {
	order: number;
	titre: string;
	description: FaqItemModel[];
	nomHtml: string;
	choices: RadioButtonModel[];
	erreurs: Record<string, string>;
}

/**
 * Model of an item in the FAQ, for example a chain of paragraphs or a bulletpoints list.
 */
export interface FaqItemModel {
	type: string;
	idFormulaire?: string;
	contenu: string[] | Record<string, FormFieldDescriptionModel> | LinkModel;
	boutonLibelle?: string;
	bannerContent?: BannerModel;
	formGroup?: FormGroup;
}

export interface FaqSectionModel {
	titre: string;
	reponses: FaqItemModel[];
}
